export interface CategoryItem {
  name: string;
  url: string;
  icon: string;
  image: string;
}

export const categories: CategoryItem[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20pair%20of%20white%20minimalist%20sneakers%20on%20a%20warm%20cream%20concrete%20surface%2C%20soft%20natural%20daylight%20from%20a%20nearby%20window%2C%20clean%20and%20simple%20composition%2C%20editorial%20product%20photography%2C%20neutral%20beige%20and%20cream%20background%2C%20calm%20sophisticated%20vibe&width=500&height=400&seq=sugargoo-cat-shoes&orientation=landscape',
  },
  {
    name: 'Hoodies & Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20minimalist%20beige%20hoodie%20neatly%20folded%20on%20a%20warm%20cream%20wooden%20surface%2C%20soft%20natural%20daylight%2C%20clean%20and%20simple%20product%20photography%2C%20calm%20and%20comfortable%20aesthetic%2C%20neutral%20earth%20tone%20palette&width=500&height=400&seq=sugargoo-cat-hoodies&orientation=landscape',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Clean%20white%20minimalist%20t-shirt%20neatly%20laid%20flat%20on%20a%20warm%20cream%20linen%20surface%2C%20soft%20natural%20daylight%2C%20simple%20and%20fresh%20product%20photography%2C%20neutral%20beige%20background%2C%20editorial%20minimal%20style&width=500&height=400&seq=sugargoo-cat-tshirts&orientation=landscape',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-honour-line',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20minimalist%20lightweight%20jacket%20draped%20on%20a%20wooden%20hanger%20against%20a%20warm%20cream%20wall%2C%20soft%20natural%20light%2C%20clean%20editorial%20product%20photography%2C%20neutral%20earth%20tone%20palette%2C%20calm%20sophisticated%20aesthetic&width=500&height=400&seq=sugargoo-cat-jackets&orientation=landscape',
  },
  {
    name: 'Pants & Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20pair%20of%20beige%20trousers%20neatly%20folded%20on%20a%20warm%20cream%20surface%2C%20soft%20natural%20daylight%2C%20clean%20and%20simple%20product%20photography%2C%20neutral%20color%20palette%2C%20editorial%20commercial%20style&width=500&height=400&seq=sugargoo-cat-pants&orientation=landscape',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-customer-service-line',
    image: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20cap%20or%20hat%20on%20a%20clean%20warm%20cream%20surface%2C%20soft%20natural%20daylight%2C%20clean%20product%20photography%2C%20neutral%20beige%20background%2C%20editorial%20minimal%20style%2C%20calm%20aesthetic&width=500&height=400&seq=sugargoo-cat-headwear&orientation=landscape',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    image: 'https://readdy.ai/api/search-image?query=Matching%20minimalist%20clothing%20set%20neatly%20arranged%20on%20a%20warm%20cream%20surface%2C%20soft%20natural%20light%2C%20clean%20product%20photography%2C%20neutral%20beige%20and%20cream%20tones%2C%20editorial%20style%2C%20calm%20sophisticated%20vibe&width=500&height=400&seq=sugargoo-cat-sets&orientation=landscape',
  },
  {
    name: 'Underwear & Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-checkbox-blank-line',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20folded%20cotton%20undergarments%20neatly%20arranged%20on%20a%20warm%20cream%20surface%2C%20soft%20natural%20daylight%2C%20clean%20and%20simple%20product%20photography%2C%20neutral%20palette%2C%20editorial%20commercial%20style&width=500&height=400&seq=sugargoo-cat-underwear&orientation=landscape',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-vip-diamond-line',
    image: 'https://readdy.ai/api/search-image?query=Sporty%20minimalist%20jersey%20neatly%20folded%20on%20a%20warm%20cream%20surface%2C%20soft%20natural%20light%2C%20clean%20product%20photography%2C%20neutral%20beige%20background%2C%20editorial%20style%2C%20calm%20athletic%20vibe&width=500&height=400&seq=sugargoo-cat-jersey&orientation=landscape',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20accessories%20including%20sunglasses%20and%20a%20watch%20on%20a%20warm%20cream%20surface%2C%20soft%20natural%20daylight%2C%20clean%20product%20photography%2C%20neutral%20beige%20tones%2C%20editorial%20sophisticated%20style&width=500&height=400&seq=sugargoo-cat-accessories&orientation=landscape',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-shopping-bag-3-line',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20canvas%20or%20leather%20bag%20on%20a%20warm%20cream%20surface%2C%20soft%20natural%20daylight%2C%20clean%20product%20photography%2C%20neutral%20beige%20background%2C%20editorial%20style%2C%20calm%20modern%20aesthetic&width=500&height=400&seq=sugargoo-cat-bags&orientation=landscape',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    image: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20leather%20belt%20elegantly%20coiled%20on%20a%20warm%20cream%20surface%2C%20soft%20natural%20light%2C%20clean%20product%20photography%2C%20neutral%20beige%20background%2C%20editorial%20style%2C%20sophisticated%20minimal%20vibe&width=500&height=400&seq=sugargoo-cat-belts&orientation=landscape',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-contrast-drop-2-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20perfume%20bottle%20on%20a%20warm%20cream%20surface%2C%20soft%20natural%20daylight%2C%20clean%20product%20photography%2C%20neutral%20beige%20background%2C%20editorial%20style%2C%20calm%20luxurious%20aesthetic&width=500&height=400&seq=sugargoo-cat-perfumes&orientation=landscape',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    image: 'https://readdy.ai/api/search-image?query=Eclectic%20minimalist%20collection%20of%20various%20small%20lifestyle%20products%20on%20a%20warm%20cream%20surface%2C%20soft%20natural%20light%2C%20clean%20product%20photography%2C%20neutral%20beige%20background%2C%20editorial%20style%2C%20calm%20organized%20aesthetic&width=500&height=400&seq=sugargoo-cat-other&orientation=landscape',
  },
];